import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_FIELDS_ON_CARD_TEXTBOX_BACKGROUND,
  DARK_TEXT,
  DARK_TEXTBOX_BORDER,
  LIGHT_TEXT,
  LIGHT_CONTAINER_FIELDS_ON_CARD,
  LIGHT_TEXTBOX_BORDER,
  PLAIN_TEXT,
  PRIMARY_TEXTBOX_BORDER_FOCUS,
} = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      color: PLAIN_TEXT,
      '& .MuiFormLabel-root': {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '13px',
        letterSpacing: '1px',
        alignItems: 'center',

        '& .MuiBox-root': {
          padding: '2px 4px 1px 5px',
          border: '1px solid',
          borderRadius: '100%',
          fontSize: '12px',
        },
      },

      '& .MuiInputBase-root': {
        '&input::placeholder': {
          color: PLAIN_TEXT,
          letterSpacing: '1px',
        },
      },
    },

    textAreaCls: {
      background:
        theme.palette.type === 'dark' ? DARK_FIELDS_ON_CARD_TEXTBOX_BACKGROUND : LIGHT_CONTAINER_FIELDS_ON_CARD,
      border: `solid 1px ${theme.palette.type === 'dark' ? DARK_TEXTBOX_BORDER : LIGHT_TEXTBOX_BORDER}`,
      color: theme.palette.type === 'dark' ? PLAIN_TEXT : 'default',
      width: '100%',
      fontSize: '14px',
      padding: '18.5px 14px',
      borderRadius: '4px',
      resize: 'none',
      outline: 'none',
      fontFamily: "'Roboto', sans-serif",
      '&:hover': {
        border: `solid 1px ${theme.palette.type === 'dark' ? LIGHT_TEXTBOX_BORDER : DARK_TEXTBOX_BORDER}`,
      },
      '&:focus': {
        border: `solid 1px ${theme.palette.type === 'dark' ? PRIMARY_TEXTBOX_BORDER_FOCUS : DARK_TEXTBOX_BORDER}`,
      },

      '& textarea::placeholder': {
        color: LIGHT_TEXT,
        letterSpacing: '1px',
        fontWeight: 700,
      },

      '& textarea::-webkit-input-placeholder': {
        color: LIGHT_TEXT,
        letterSpacing: '1px',
        fontWeight: 700,
      },

      '& textarea::-ms-input-placeholder': {
        color: LIGHT_TEXT,
        letterSpacing: '1px',
        fontWeight: 700,
      },
    },

    withLabel: {
      marginTop: '10px',
    },

    labelColor: {
      color: (theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT) + '!important',
    },
  }),
);
